import { localizedLegalPage } from "./localized";
import { LegalNoticePage as Fr } from "./fr/LegalNoticePage";
import { LegalNoticePage as En } from "./en/LegalNoticePage";

export const LegalNoticePage = localizedLegalPage({ fr: Fr, en: En });

export default LegalNoticePage;
